// Minimal pub/sub for cross-component communication.
export const EVENT = {
  LANGUAGE_CHANGED: 'language:changed',
  THEME_CHANGED: 'theme:changed',
  TAB_CHANGED: 'tab:changed',
  TAB_REQUESTED: 'tab:requested',
  NOTIFICATIONS_UPDATED: 'notifications:updated',
};

const listeners = new Map();

export function on(name, fn) {
  if (!listeners.has(name)) listeners.set(name, new Set());
  listeners.get(name).add(fn);
  return () => listeners.get(name).delete(fn);
}

export function emit(name, payload) {
  const set = listeners.get(name);
  if (!set) return;
  set.forEach((fn) => { try { fn(payload); } catch (e) { console.error(e); } });
}